<template>
  <div class="payDetail">
    <div class="top" style="border-bottom: 1px solid #dcdfe6">
      <div v-if="targetName || stationName" class="current-title">
        当前查看：{{ targetName || stationName }} 的订单分润明细
      </div>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        size="medium"
      >
        <el-form-item label="充电单号">
          <el-input
            v-model="formInline.user"
            placeholder="请输入充电单号"
          />
        </el-form-item>
        <el-form-item label="充电枪编码">
          <el-input
            v-model="formInline.id"
            placeholder="请输入充电枪编码"
          />
        </el-form-item>
        <el-form-item label="是否结算">
          <el-select
            v-model="formInline.settled"
            placeholder="请选择"
            clearable
            style="width: 120px"
          >
            <el-option label="未结算" :value="0" />
            <el-option label="已结算" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间区间">
          <el-button type="text" :class="timeType === 'DAY' ? 'active' : ''" @click="chooseType('DAY')">今日</el-button>
          <el-button type="text" :class="timeType === 'MONTH' ? 'active' : ''" @click="chooseType('MONTH')">本月</el-button>
          <el-button type="text" :class="timeType === 'YEAR' ? 'active' : ''" @click="chooseType('YEAR')">本年</el-button>
          <el-button type="text" :class="timeType === 'ALL' ? 'active' : ''" @click="chooseType('ALL')">全部</el-button>
          <el-date-picker
            v-model="form.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="dateRangeOptions"
            size="small"
            style="width: 260px; margin-left: 10px"
            @change="chooseCustom"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" plain @click="backFn">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content" style="position: relative">
      <el-button type="primary" style="margin-top: 20px" @click="exportOrder">导出</el-button>
      <el-button type="warning" style="margin-top: 20px" :disabled="multipleSelection.length === 0" @click="settleOrders">批量结算</el-button>
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 100%; margin-top: 20px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="50" />
        <el-table-column type="index" align="center" width="50" label="序号" />
        <el-table-column label="充电单号" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="gotoDetail(scope.row)">{{ scope.row.startChargeSeq }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="电站名称" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.stationName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="充电枪编码" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.connectorID }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户归属企业" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.accountOrgName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="充电度数" align="center">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.power) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收电费" align="center">
          <template slot-scope="scope">
            <span>{{ getFixed2(scope.row.elecMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收服务费" align="center">
          <template slot-scope="scope">
            <span>{{ getFixed2(scope.row.serviceMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否结算" align="center" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.settled === 1 ? 'success' : 'info'">
              {{ scope.row.settled === 1 ? '已结算' : '未结算' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="运营商分润" align="center">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.operatorProfit) }}</span>
          </template>
        </el-table-column>
        <template v-if="tableProfit && tableProfit.length>0">
          <el-table-column v-for="(item,index) in tableProfit" :key="index" :label="item.targetName" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row[item.targetId] || scope.row[item.targetId]===0">{{ getFloat(scope.row[item.targetId]) }}</span>
              <span v-else> -- </span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      v-if="pageshow"
      style="margin-top: 20px"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  data() {
    return {
      stationId: '',
      stationName: '',
      targetId: '',
      targetName: '',
      timeType: '',
      startTime: '',
      endTime: '',
      form: {
        dateRange: []
      },
      dateRangeOptions: {
        disabledDate(time) {
          // 禁止选择今天之后的日期
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      formInline: {
        user: '',
        id: ''
      },
      tableProfit: [],
      tableData: [],
      multipleSelection: [],
      pageshow: true,
      currentPage: 1, // 当前页
      total: 100, // 总页数
      pagesize: 10 // 每页条数
    }
  },
  beforeMount() {
    this.stationId = this.$route.query.stationId
    this.stationName = this.$route.query.stationName
    this.targetId = this.$route.query.targetId
    this.targetName = this.$route.query.targetName
    this.timeType = this.$route.query.timeType || 'DAY'
    this.startTime = this.$route.query.startTime
    this.endTime = this.$route.query.endTime
    if (this.startTime && this.endTime) {
      this.timeType = 'CUSTOM'
      this.form.dateRange = [this.startTime, this.endTime]
    }
  },
  mounted() {
    this.getProfitData()
    this.getPageData()
  },
  methods: {
    backFn() {
      this.$router.go(-1)
    },
    gotoDetail(item) {
      this.$router.push({ path: '/orderManagement/historyDetail', query: { data: item.orderId, num: item.startChargeSeq }})
    },
    handleSizeChange(val) {
      this.pageshow = false
      this.pagesize = val
      this.tableData = []
      this.getPageData()
    },

    handleCurrentChange(val) {
      this.pageshow = false
      this.currentPage = val
      this.tableData = []
      this.getPageData()
    },

    getProfitData() {
      const data = {
        stationId: this.stationId,
        targetId: this.targetId,
        timeType: this.timeType,
        startTime: this.startTime,
        endTime: this.endTime,
        startChargeSeq: this.formInline.user,
        connectorID: this.formInline.id,
        settled: this.formInline.settled
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/profit/detail/order/targets',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp && resp.length > 0) {
            this.tableProfit = resp
          } else {
            this.tableProfit = []
          }
        }
      })
    },
    getPageData() {
      const data = {
        stationId: this.stationId,
        targetId: this.targetId,
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        timeType: this.timeType,
        startTime: this.startTime,
        endTime: this.endTime,
        startChargeSeq: this.formInline.user,
        connectorID: this.formInline.id,
        settled: this.formInline.settled
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/profit/detail/order/page',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.tableData = resp.list
            this.pageshow = true
          } else {
            this.pageshow = false
            this.tableData = []
          }
          this.currentPage = resp.pageNo
          this.total = resp.count
          this.pagesize = resp.pageSize
        }
      })
    },
    exportOrder() {
      const url = HOST + '/finance/profit/detail/order/export'
      $.fileDownload(url, {
        httpMethod: 'get',
        data: {
          stationId: this.stationId,
          targetId: this.targetId,
          pageNo: this.currentPage,
          pageSize: this.pagesize,
          timeType: this.timeType,
          startTime: this.startTime,
          endTime: this.endTime,
          startChargeSeq: this.formInline.user,
          connectorID: this.formInline.id,
          token: window.localStorage.getItem('token')
        },
        failCallback: (html, url) => {
          this.$notify({
            title: '失败',
            message: '导出失败',
            type: 'error'
          })
        }
      })
    },
    chooseType(val) {
      this.timeType = val
      this.form.dateRange = []
      this.startTime = ''
      this.endTime = ''
    },
    chooseCustom(val) {
      // 使用自定义时间区间
      if (val && val.length === 2) {
        this.timeType = 'CUSTOM'
        this.startTime = val[0]
        this.endTime = val[1]
      } else {
        this.form.dateRange = []
        this.startTime = ''
        this.endTime = ''
      }
    },
    onSubmit() {
      if (this.form.dateRange && this.form.dateRange.length === 2) {
        this.timeType = 'CUSTOM'
        this.startTime = this.form.dateRange[0]
        this.endTime = this.form.dateRange[1]
      } else {
        this.startTime = ''
        this.endTime = ''
      }
      this.getProfitData()
      this.getPageData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    settleOrders() {
      if (this.multipleSelection.length === 0) {
        this.$notify({
          title: '提示',
          message: '请先勾选要结算的订单',
          type: 'warning'
        })
        return
      }
      const orderIds = this.multipleSelection.map(item => item.orderId)
      this.$confirm('确定要将选中的 ' + orderIds.length + ' 笔订单标记为已结算吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('form/handle', {
          url: '/finance/profit/settle',
          data: orderIds,
          method: 'post',
          callback: resp => {
            this.$notify({
              title: '成功',
              message: '结算成功',
              type: 'success'
            })
            this.getProfitData()
            this.getPageData()
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less">
.payDetail {
  .current-title {
    padding: 8px 12px;
    margin-bottom: 10px;
    font-size: 14px;
    color: #409eff;
    background: #ecf5ff;
    border-radius: 4px;
  }
  .el-form {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .el-form-item {
      margin-right: 20px;
      margin-bottom: 0;
      .active {
        color: #409eff;
        border-bottom: 2px solid #409eff;
      }
      .el-button--text {
        width: 55px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/payDetail.vue